import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import { templateKeys } from './useTemplates';
import type { Template } from '../../lib/types/template.types';

/**
 * Fetch a single template by ID
 *
 * @param id - Template ID
 * @returns Query result with template details
 *
 * @example
 * const { data: template, isLoading } = useTemplate(templateId);
 */
export function useTemplate(id: string | undefined) {
  return useQuery({
    queryKey: templateKeys.detail(id || ''),
    queryFn: async () => {
      if (!id) throw new Error('Template ID is required');
      const { data } = await api.get<Template>(`/api/templates/${id}`);
      return data;
    },
    enabled: !!id,
    staleTime: 1000 * 60, // 1 minute
  });
}
